// antd v3'te az_AZ paketi yok; Azerice'ye en yakin okunabilir secenek tr_TR.
// Sadece antd'nin kendi metinleri (Tamam / Iptal / tarih secici) etkilenir.
import antdAz from "antd/lib/locale-provider/tr_TR";
import appLocaleData from "react-intl/locale-data/az";
import enMessages from "../locales/en_US.json";
import azMessages from "../locales/az_AZ.json";

const AzLang = {
  messages: {
    ...enMessages,
    ...azMessages
  },
  antd: antdAz,
  locale: 'az',
  data: appLocaleData
};
export default AzLang;
